// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  presenceId: __t.u64().primaryKey().name("presence_id"),
  sessionId: __t.u64().name("session_id"),
  positionX: __t.f64().name("position_x"),
  positionY: __t.f64().name("position_y"),
  positionZ: __t.f64().name("position_z"),
  rotationPitch: __t.f32().name("rotation_pitch"),
  rotationYaw: __t.f32().name("rotation_yaw"),
  rotationRoll: __t.f32().name("rotation_roll"),
  lookX: __t.f32().name("look_x"),
  lookY: __t.f32().name("look_y"),
  lookZ: __t.f32().name("look_z"),
  velocityX: __t.f32().name("velocity_x"),
  velocityY: __t.f32().name("velocity_y"),
  velocityZ: __t.f32().name("velocity_z"),
  sequenceNumber: __t.u64().name("sequence_number"),
  lastUpdate: __t.timestamp().name("last_update"),
  geoLat: __t.option(__t.f64()).name("geo_lat"),
  geoLon: __t.option(__t.f64()).name("geo_lon"),
  geoElev: __t.option(__t.f64()).name("geo_elev"),
  headingDeg: __t.option(__t.f32()).name("heading_deg"),
  pitchDeg: __t.option(__t.f32()).name("pitch_deg"),
  vfovDeg: __t.option(__t.f32()).name("vfov_deg"),
  aspect: __t.option(__t.f32()),
});
